import { makeAutoObservable } from 'mobx';
// import { postApi } from '@/utils/request';
const TOKEN_KEY = 'access-token';

class RootStore {
  grantType;
  mobileNumber;
  countryCode = 1;
  countryId = 'US'; // ISO 3166-1 alpha-2 国家代码，用于区分相同电话区号的国家
  email;
  thirdpartyId;
  thirdpartyAccessToken;
  code;
  name;
  gender;
  profilePictures = new Array(6);
  birthdate;
  currentResidence;
  description;
  profileTags;
  visitorId;
  token;
  deleteTime;
  curModal = null;
  scene = 'account'; // 'account' for login/register, 'retrieve-data' for account deletion
  deletedUserPhone = ''; // 已删除用户的手机号（来自三方登录返回）
  deletedUserEmail = ''; // 已删除用户的邮箱（来自三方登录返回）
  loginGrantType = ''; // 原始登录方式 (google/apple/facebook/phone)
  bindPhoneMode = false; // 是否在绑定手机号模式（三方登录用户无手机号/邮箱时）
  downloadSubmitted = false; // 下载请求已提交标记

  constructor() {
    makeAutoObservable(this);
    // typeof localStorage !== 'undefined' && this.loadFromLocalStorage(); // 从localStorage加载数据
  }

  setCurModal = (modal) => {
    this.curModal = modal;
  };

  updateKey = (key, value) => {
    this[key] = value;
    this.saveToLocalStorage();
  };

  loadFromLocalStorage() {
    const storedData = localStorage.getItem('rootStore');
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      Object.keys(parsedData).forEach((key) => {
        this[key] = parsedData[key];
      });
    }
  }

  saveToLocalStorage() {
    const dataToStore = {};
    Object.keys(this).forEach((key) => {
      if (typeof this[key] !== 'function') {
        dataToStore[key] = this[key];
      }
      // if(key === 'profilePictures'){

      // }
    });
    if (dataToStore.token) {
      localStorage.setItem(TOKEN_KEY, dataToStore.token);
    }
    localStorage.setItem('rootStore', JSON.stringify(dataToStore));
  }

  register = async () => {
    const obj = {
      grantType: this.grantType,
      mobileNumber: this.mobileNumber,
      countryCode: this.countryCode,
      email: this.email,
      thirdpartyId: this.thirdpartyId,
      thirdPartyAccessToken: this.thirdpartyAccessToken,
      code: this.code,
      name: this.name,
      gender: this.gender,
      profilePictures: this.profilePictures.filter((item) => item?.length > 0),
      birthdate: this.birthdate,
      currentResidence: this.currentResidence,
      description: this.description,
      profileTags: this.profileTags,
    };

    // function jsonToFormData(jsonObject) {
    //   const formData = new FormData();
    //   Object.keys(jsonObject).forEach((key) => {
    //     if (key === 'profilePictures') {
    //       jsonObject[key].forEach((item, index) => {
    //         if (item instanceof Blob) {
    //           console.log('size====', item.size);
    //           // 为每个Blob元素创建一个键，例如 'picture0', 'picture1', ...
    //           formData.append('profilePictures', item, `profilePicture${index + 1}.jpeg`);
    //           formData.append(`size${index}`, String(item.size));
    //         }
    //       });
    //     } else if (jsonObject[key] instanceof Array) {
    //       // 如果值是数组，需要为数组中的每个元素创建单独的键
    //       jsonObject[key].forEach((value, index) => {
    //         formData.append(`${key}[${index}]`, value);
    //       });
    //     } else if (jsonObject[key]) {
    //       // 对于非数组值，直接添加到FormData
    //       formData.append(key, jsonObject[key]);
    //     }
    //   });
    //   return formData;
    // }

    const res = await fetch(`${window.location.protocol}//${window.location.host}/web/register`, obj);
    localStorage.removeItem('rootStore');

    return res;
  };
}

export const rootStore = new RootStore();
